<template>
  <div>
    <b-container>
      <b-row>
        <b-col md="6">
          <FormulateInput
            type="text"
            label="Student Name"
            :value="studentInfo ? `${studentInfo.firstName} ${studentInfo.lastName}` : '' "
            disabled
          />
        </b-col>
        <b-col md="6">
          <FormulateInput
            type="text"
            label="Student ID"
            :value="studentInfo ? `${studentInfo.studentId}` : '' "
            disabled
          />
        </b-col>
      </b-row>
      <FormulateForm v-model="formValues"
        class="form-wrapper"
        @submit="onSubmit"
        #default="{ isLoading }"
        name="requestForm"
      > 
        <b-row>
            <b-col md="12" class="mt-4">
              <FormulateInput
                type="date"
                name="endDate"
                label="Last Date of Transportation"
                validation-name="End Date"
                help="Sample date help text sample sample sample"
                :min="startDate ? startDate : today()"
                :validation="[
                  ['^required'],
                  ['afterToday']
                ]"
                :validation-rules="{
                  afterToday: ({ value }) => new Date(value) >= new Date(),
                }"
                :validation-messages="{
                  afterToday:`Start date should later than today`,
                }"
              />
            </b-col>
            <!-- <b-col md="12" class="mt-1">
              <p class="form-text text-muted mt-4">
                Please select the transportation directions you want to cancel.
              </p>
              <FormulateInput
                class="ml-3 mr-3"
                type="radio"
                name="direction"
                :options="{I: 'Inbound (to school)', O: 'Outbound (from school)', B: 'Both' }"
                validation="required"
                validation-name="Direction"
              />
            </b-col> -->
            <b-col md="12">
              <FormulateInput
                class="mt-3"
                label="Additional Information"
                placeholder="Optional."
                type="textarea"
                name="notes"
              />
            </b-col>
            <b-col md="12" class="text-center mt-3 mb-3">
              <FormulateErrors />
              <FormulateInput
                class="mt-3"
                type="submit"
                :disabled="isLoading"
                :label="isLoading ? 'Loading...' : 'Submit Cancellation'"
                validation-behavior="live"
                help="this is a help"
                />
            </b-col>
        </b-row>
      </FormulateForm>
      Endpoint Data: {{ formValues }} <p></p>
    </b-container>
  </div>
</template>

<script>
  import { postNewCancelForm } from '../services/api.js';

  export default {
    props: { startDate: {}, studentInfo: {}},
    data() {
      return {
        formValues: {},
      }
    },
    methods: {
      async onSubmit () {
        try {
          let response = await postNewCancelForm(this.formValues, this.studentInfo.internalId)
          if (response.status !== 202){
            throw new Error(response.statusText);
          }
          let body = await response.data; // or .json() or whatever
          console.log(body)
          // process body
          this.formValues = {};
          alert('All validation complete, form submitted.')
          this.$root.$emit('bv::hide::modal', 'cancel-modal')
        } catch (err) {
          alert('Form submission failed!')
          console.log(err)
        }
      },
      scroll(id) {
        const el = document.getElementsByClassName(id)[0];
        if(el){
          el.scrollIntoView({behavior: "smooth"});
        }
      },
      today() {
        var today = new Date();
        var month = today.getMonth() + Number(1);
        if (month < 10) {
          month = '0'+month;
        }
        var date = today.getDate();
        if (date < 10) {
          date = '0'+date;
        }
        return today.getFullYear() +'-'+ month +'-'+ date
      },
    },
  }
</script>